module.exports = __webpack_public_path__ + "static/media/morse-code-print.934812e3.svg";